import { useContext } from 'react';
import { apiClientContext } from './apiClientContext';
export var useApiClient = function () {
    var context = useContext(apiClientContext);
    if (context) {
        return context;
    }
    throw new Error('ApiClientContext value must be set.');
};

